<template>
  <img
    v-if="normalizedType"
    :src="iconPath"
    :alt="`card-type-icon-${normalizedType}`"
    :title="normalizedType"
    role="presentation"
    :class="{
      'icon--card-type': size === 'normal',
      'icon--card-type__small': size === 'small',
      'icon--card-type__large': size === 'large',
      'icon--card-type__custom-design': cardDesignUrl
    }"
  >
</template>

<script>
  export default {
    name: 'CardTypeIcon',

    props: {
      cardType: {
        type: String,
        default: null
      },
      paymentType: {
        type: String,
        default: null
      },
      size: {
        type: String,
        default: 'normal'
      },
      cardDesignUrl: {
        type: String,
        default: null
      }
    },

    computed: {
      normalizedType() {
        const type = ['ApplePay', 'GooglePay', 'GiftCard'].includes(this.paymentType)
          ? this.paymentType
          : this.cardType;

        return type?.toLowerCase().replace(/[\s_]/g, '-');
      },

      iconPath() {
        if (this.cardDesignUrl) {
          return this.cardDesignUrl;
        }

        switch (this.normalizedType) {
          case 'amex':
          case 'american-expres': /* AMEX cards saved via Square will sometimes have this misspelled cardType */
          case 'american-express':
            return '/images/payment-methods/amex.svg';

          case 'applepay':
            return '/images/apple-pay-mark.svg';

          case 'diners-club':
          case 'discover-diners':
            return '/images/payment-methods/diners-club.svg';

          case 'disc':
          case 'discover':
            return '/images/payment-methods/discover.svg';

          case 'giftcard':
            return '/images/payment-methods/gift-card.svg';

          case 'googlepay':
            return '/images/google-pay-mark.svg';

          case 'jcb':
            return '/images/payment-methods/jcb.svg';

          case 'mc':
          case 'mastercard':
            return '/images/payment-methods/mastercard.svg';

          case 'pay-pal':
            return '/images/payment-methods/pay-pal.svg';

          case 'venmo':
            return '/images/payment-methods/venmo.svg';

          case 'visa':
            return '/images/payment-methods/visa.svg';

          default:
            return '/images/payment-methods/generic.svg';
        }
      }
    }
  };
</script>
